/**
 * "Trợ lý của tôi" (S8 §9, D85): the page's address and its tabs, in the mockup's order. A tab is deep-linked by
 * `?tab=<slug>`; a slug the page does not know, or a tab not built yet, is replaced by the default.
 */

export const ASSISTANT_ME_PATH = '/assistant/me';
export const ASSISTANT_ME_TITLE = 'Trợ lý của tôi';

export const ME_TABS = [
  { slug: 'tro-ly', label: 'Trợ lý' },
  { slug: 'loi-dan', label: 'Lời dặn riêng' },
  { slug: 've-toi', label: 'Về tôi' },
  { slug: 'nhip', label: 'Nhịp làm việc' },
  { slug: 'tri-nho', label: 'Trí nhớ' },
  { slug: 'ket-noi', label: 'Kết nối' },
] as const;
export type MeTab = (typeof ME_TABS)[number]['slug'];

/** The tabs on screen: all six. */
export const BUILT_TABS: ReadonlySet<MeTab> = new Set<MeTab>(ME_TABS.map((t) => t.slug));
export const DEFAULT_TAB: MeTab = 'tro-ly';
/** D139: with the assistant off, only "Về tôi" (what the person is, which the people around them still read). */
export const OFF_TABS: ReadonlySet<MeTab> = new Set<MeTab>(['ve-toi']);
export const OFF_DEFAULT_TAB: MeTab = 've-toi';

/** The tabs on screen, in the mockup's order: all six, or only "Về tôi" with the assistant off (D139). */
export const visibleTabs = (aiOff: boolean) => ME_TABS.filter((t) => (aiOff ? OFF_TABS : BUILT_TABS).has(t.slug));

/**
 * D88: the tab that edits a `/me` body field, from a 422's dotted `fields` key (`personality.formality`,
 * `focus.projectIds.0`): its first segment decides.
 */
const FIELD_TABS: Record<string, MeTab> = {
  personaName: 'tro-ly', selfName: 'tro-ly', appearance: 'tro-ly', personality: 'tro-ly', preferredModelId: 'tro-ly',
  instructions: 'loi-dan',
  addressAs: 've-toi', addressCustom: 've-toi', roleTitle: 've-toi', focus: 've-toi',
  readOnly: 'nhip', reducedMotion: 'nhip',
};
export const tabOfField = (path: string): MeTab | null => FIELD_TABS[path.split('.')[0]!] ?? null;

/** The tab a `?tab=` value names, or `null` for one that is unknown, not built, or hidden with the assistant off. */
export const meTabOf = (value: string | null, aiOff = false): MeTab | null =>
  visibleTabs(aiOff).find((t) => t.slug === value)?.slug ?? null;

/** A link to one tab of the page, at an anchor inside it when `hash` is given. */
export const tabHref = (tab: MeTab, hash?: string): string =>
  `${ASSISTANT_ME_PATH}?tab=${tab}${hash === undefined ? '' : `#${hash}`}`;

export const meTabId = (tab: MeTab): string => `assistant-me-tab-${tab}`;
export const mePanelId = (tab: MeTab): string => `${meTabId(tab)}-panel`;
